import {toast} from "react-toastify";
import ApiConnect from "../../Utils/ApiConnect";
import {SalesPurchaseAction} from "../contants/Modules.Action.Type";

export const SalesChangeHandler =
  (e, data = false) =>
    (dispatch, getstate) => {
      let Sales = getstate().SalesPurchase.Sales;
      if (!data) {
        if (e.target) {
          Sales[e.target.name] = e.target.value;
        } else {
          Sales["account"] = e;
        }
      } else {
        Sales[data] = e;
      }
      dispatch({
        type: SalesPurchaseAction.SALES_CHANGE_HANDLER,
        payload: { Sales },
      });
      if (
        !data &&
        e.target &&
        (e.target.name === "rate" || e.target.name === "route")
      ) {
        dispatch(
          RateToggleChange(
            e.target.name === "rate" ? e.target.value : false,
            e.target.name === "route" ? e.target.value : false
          )
        );
      } else if (!data && e.target && e.target.name === "tax");
      {
        dispatch(SalesCalculation());
      }
    };

export const RateToggleChange =
  (Ratestype = false, routeid = false) =>
    (dispatch, getstate) => {
      const SalesData = getstate().SalesPurchase.Sales;
      const particular = SalesData.particulars.slice();
      if (particular.length !== 0) {
        ApiConnect.get(
          `/Module/Inventory/Product/Rate?id=${particular[0].id}&route=${routeid ? routeid : SalesData.route
          }&type=${Ratestype ? Ratestype : SalesData.rate}&party=${SalesData.account.id
          }`
        )
          .then((response) => {
            const sellRate = parseFloat(response.data.sell_price);
            particular.forEach((x) => {
              const totalQty =
                parseFloat(x.qty) + (x.damage ? parseFloat(x.damage) : 0);
              const netTotal = totalQty * sellRate;
              const txtAmt = parseFloat(x.taxAmt);
              x.netAmt = netTotal + txtAmt;
              x.rate = sellRate;
            });
          })
          .catch((error) => {
            console.log(error);
          });
        const Sales = SalesData;
        Sales.particulars = particular;
        dispatch({
          type: SalesPurchaseAction.SALES_RATE_CHANGE,
          payload: { Sales },
        });
        dispatch(SalesCalculation());
      }
    };

export const SalesAddParticular = (e) => (dispatch, getstate) => {
  let alreadyExists = false;
  const SalesData = getstate().SalesPurchase.Sales;
  const particular = SalesData.particulars.slice();
  particular.forEach((x) => {
    if (x.id === e.id) {
      alreadyExists = true;
      x.qty = parseFloat(x.qty) + parseFloat(e.qty);
      x.damage = parseFloat(x.damage) + e.damage ? parseFloat(e.damage) : 0;
      x.free = parseFloat(x.free) + parseFloat(e.free);
      x.netAmt = parseFloat(x.netAmt) + parseFloat(e.netAmt);
      x.taxAmt = parseFloat(x.taxAmt) + parseFloat(e.taxAmt);
    }
  });
  if (!alreadyExists && e.product) {
    let newdata = {
      name: e.product,
      id: e.id,
      qty: parseFloat(e.qty),
      free: parseFloat(e.free),
      rate: parseFloat(e.rate),
      damage: e.damage ? parseFloat(e.damage) : 0,
      tax: parseFloat(e.tax),
      taxAmt: parseFloat(e.taxAmt),
      netAmt: parseFloat(e.netAmt),
    };
    particular.push({ ...newdata });
  }
  const Sales = SalesData;
  Sales.particulars = particular;
  dispatch({
    type: SalesPurchaseAction.ADD_PARTICULAR,
    payload: { Sales },
  });
  dispatch(SalesCalculation());
};

export const removeSalesParticular = (e) => (dispatch, getstate) => {
  const SalesData = getstate().SalesPurchase.Sales;
  let Particular = SalesData.particulars.slice();
  const selectProduct = Particular.find((items) => items.id === e.id);
  const index = Particular.indexOf(selectProduct);
  Particular.splice(index, 1);
  const Sales = SalesData;
  Sales.particulars = Particular;
  dispatch({
    type: SalesPurchaseAction.REMOVE_SALES_PARTICULAR,
    payload: { Sales },
  });
  dispatch(SalesCalculation());
};

export const SalesCalculation = () => (dispatch, getstate) => {
  const SalesData = getstate().SalesPurchase.Sales;
  const netamount = parseFloat(
    SalesData.particulars.reduce((sum, i) => (sum += parseFloat(i.netAmt)), 0)
  );
  const TaxAmount = parseFloat((netamount * SalesData.tax) / 100);
  const Sales = SalesData;
  Sales.netAmount = netamount;
  Sales.taxAmount = TaxAmount;
  Sales.grandTotal = parseFloat((netamount + TaxAmount).toFixed(2));
  dispatch({
    type: SalesPurchaseAction.SALES_TOTAL_CALCULATION,
    payload: Sales,
  });
};

export const SalesSetToDefault = () => (dispatch) => {
  const Sales = {
    account: [],
    date: false,
    route: "",
    type: "Estimate",
    payment: "Credit",
    AmountReceive: 0,
    vehicle: "",
    rate: "Retail",
    particulars: [],
    netAmount: 0,
    tax: 0,
    taxAmount: 0,
    grandTotal: 0,
    remark: "",
    docs: [],
  };
  dispatch({
    type: SalesPurchaseAction.SALES_SET_TO_DEFAULT,
    payload: { Sales },
  });
};

export const SalesEntryPost = () => (dispatch, getstate) => {
  const SalesData = getstate().SalesPurchase.Sales;
  const particular = SalesData.particulars;
  var Fdata = new FormData();
  Fdata.append("date", SalesData.date);
  Fdata.append("account", SalesData.account.id);
  Fdata.append("type", SalesData.type);
  particular.forEach((x) => {
    Fdata.append("product[]", x.name);
    Fdata.append("id[]", x.id);
    Fdata.append("qty[]", x.qty);
    Fdata.append("rate[]", x.rate);
    Fdata.append("free[]", x.free);
    Fdata.append("tax[]", x.tax);
    Fdata.append("taxAmount[]", x.taxAmt);
    Fdata.append("netAmount[]", x.netAmt);
  });
  Fdata.append("subTotal", SalesData.netAmount);
  Fdata.append("companyTax", SalesData.tax);
  Fdata.append("CompanyTaxAmount", SalesData.taxAmount);
  Fdata.append("Total", SalesData.grandTotal);
  Fdata.append("note", SalesData.remark);
  Fdata.append("images_files", SalesData.docs);
  ApiConnect({
    method: "post",
    url: "/Module/SalesPurchase/Sales/NewSalesEntry",
    data: Fdata,
  })
    .then((response) => {
      if (response.data.status === 406) {
      } else if (response.data.status === 201) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
      } else if (response.data.status) {
        toast.danger(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
      }
    })
    .catch((error) => console.log(error));
};